import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import './style.scss';
import Order from "./Order/Order";
import GroupedOrders from "./GroupedOrders/GroupedOrders";
import {evaluateOrderGroups} from "../../../Utils/OrdersGrouping";

const OrdersGrid = forwardRef((props, ref) => {
    const ordersGridRef = useRef();
    const [orderGroups, setOrderGroups] = useState([]);

    useEffect(() => {
        if (!props.isMerukazotEnabled)
            setOrderGroups(props.orders.map(order => [order]));
        else
            setOrderGroups(evaluateOrderGroups(props.orders, props.merukazotMin, props.ignoredOrderIdsForGrouping));
    }, [props.ignoredOrderIdsForGrouping, props.orders, props.isMerukazotEnabled, props.merukazotMin]);

    const onOrderClicked = (orderId) => {
        if (props.onOrderClicked) props.onOrderClicked(orderId);
    };

    const onOrderDepartureChanged = (orderId, newDeparture) => {
        if (props.onOrderDepartureChanged) props.onOrderDepartureChanged(orderId, newDeparture);
    };

    const onOrderDeleteClicked = (orderId) => {
        if (props.onOrderDeleteClicked) props.onOrderDeleteClicked(orderId);
    };

    const onOrderEditClicked = (orderId) => {
        if (props.onOrderEditClicked) props.onOrderEditClicked(orderId);
    };

    const onOrderHover = (orderId) => {
        if (props.onOrderHover) props.onOrderHover(orderId);
    };

    const onOrderHoverOut = (orderId) => {
        if (props.onOrderHoverOut) props.onOrderHoverOut(orderId);
    };

    const onOrderBadAddressClick = (orderId) => {
        if (props.onOrderBadAddressClick) props.onOrderBadAddressClick(orderId);
    };

    const onGroupOffClicked = (orderIds) => {
        if (props.onGroupOffClicked) props.onGroupOffClicked(orderIds);
    };

    useImperativeHandle(ref, () => ({
        scrollTo(orderId) {
            if (orderId && ordersGridRef && ordersGridRef.current) {
                const foundNode = ordersGridRef.current.querySelector(`#order-${orderId}`);

                if (foundNode) foundNode.scrollIntoView({
                    behavior: "smooth"
                });
            }
        }
    }));

    return (<div className="orders-grid" ref={ordersGridRef}>
        {orderGroups.map(orderGroup => {
            const order = orderGroup[0];

            if (orderGroup.length > 1) {
                return (<GroupedOrders key={`order-${order.id}`}
                                       groupCount={orderGroup.length}
                                       id={`order-${order.id}`}
                                       onClick={() => onOrderClicked(order.id)}
                                       isFaded={props.focusedOrderId && props.focusedOrderId !== order.id}
                                       orders={orderGroup}
                                       allowEdit={order.allowEdit}
                                       readySla={props.readySla}
                                       isScheduleNotificationsEnabled={props.isScheduleNotificationsEnabled}
                                       isRedirect={props.isRedirect}
                                       isAutopilot={props.isAutopilot}
                                       onDepartureChanged={(newDeparture) => onOrderDepartureChanged(order.id, newDeparture)}
                                       onGroupOffClicked={() => onGroupOffClicked(orderGroup.map(order => order.id))}
                                       onHover={() => onOrderHover(order.id)}
                                       onHoverOut={() => onOrderHoverOut(order.id)}
                                       onBadAddressClick={() => onOrderBadAddressClick(order.id)}
                />);
            }

            return (<Order key={`order-${order.id}`}
                           id={`order-${order.id}`}
                           onClick={() => onOrderClicked(order.id)}
                           isFaded={props.focusedOrderId && props.focusedOrderId !== order.id}
                           order={order}
                           allowEdit={order.allowEdit}
                           readySla={props.readySla}
                           isScheduleNotificationsEnabled={props.isScheduleNotificationsEnabled}
                           isRedirect={props.isRedirect}
                           isAutopilot={props.isAutopilot}
                           onDepartureChanged={(newDeparture) => onOrderDepartureChanged(order.id, newDeparture)}
                           onDeleteClicked={() => onOrderDeleteClicked(order.id)}
                           onEditClicked={() => onOrderEditClicked(order.id)}
                           onHover={() => onOrderHover(order.id)}
                           onHoverOut={() => onOrderHoverOut(order.id)}
                           onBadAddressClick={() => onOrderBadAddressClick(order.id)}
            />);
        })}
    </div>);
});

export default OrdersGrid;